import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isEmpty, last, noop } from 'lodash';
import {
  getCustomerOffer,
  createApplication,
  showErrorNotification,
  getUserStatistic,
} from 'actions/clz/0bod';
import { any, arrayOf, bool, func, objectOf } from 'prop-types';
import SwitchButton from 'components/common/SwitchButton';
import { Collapse } from 'components/common/Collapse';
import Button from 'components/common/Button';
import Modal from 'components/common/Modal';
import { Slider } from 'homecredit-ui';
import FullLoading from 'components/common/FullLoading/FullLoading';
import Cycle from 'components/common/FullLoading/Cycle';
import { MESSAGE } from 'constants/internal';
import { sendGAEvent } from 'utils/ga';
import CredoUtils from 'utils/credo';
import { formatCurrency } from 'utils/string';

import s from './style.css';
import {
  getMonthlyResult,
  getAmountList,
  getAmountObj,
  getDefaultAmount,
} from './util';
import {
  INCLUDE_LIFE_INSURANCE,
  LIFE_INSURANCE_NO,
  LIFE_INSURANCE_YES,
  MILLION,
  UNINCLUDE_LIFE_INSURANCE,
  MIN_AMOUNT_NUMBER,
  LIMIT_MAX_AMOUNT_NUMBER,
  LIMIT_MIN_AMOUNT,
  STEP,
} from './constant';
import SliderDesc from './sliderDesc';

const FullLoadingCycle = FullLoading(Cycle);
class LoanCalculator extends React.Component {
  static propTypes = {
    offer: objectOf(any),
    tenors: arrayOf(any),
    onGetTenors: func,
    loading: bool,
  };
  static defaultProps = {
    offer: {},
    tenors: [],
    onGetTenors: noop,
    loading: false,
  };

  constructor(props) {
    super(props);
    const {
      offer: {
        offerData: {
          maximalCreditAmount: { amount },
        },
      },
      tenors,
    } = props;

    const amountNumber = Math.floor(amount / MILLION);

    const startAmountNumber =
      amountNumber >= LIMIT_MAX_AMOUNT_NUMBER
        ? LIMIT_MAX_AMOUNT_NUMBER
        : Math.floor(amountNumber * LIMIT_MIN_AMOUNT);

    const startAmount = getDefaultAmount(startAmountNumber);
    const tenorIndex = this.getIndexTenor(tenors);
    const tenor = tenors[tenorIndex]?.value || '';

    this.state = {
      visible: false,
      hasLifeInsurance: LIFE_INSURANCE_YES,
      errorMessage: '',
      amount: startAmount,
      tenor,
      amountIndex: startAmountNumber,
      tenorIndex,
    };
  }

  componentDidMount() {
    const { amount } = this.state;
    this.getCustomerOffer(amount);
    sendGAEvent(
      'Visit_Page',
      'New_Customer_Loan_Calculator_Page',
      'ACL_0BOD_New_Customer_Loan_Calculator',
    );
  }

  onChangeAmount = amount => {
    if (amount !== this.state.amount) {
      this.setState({ hasLifeInsurance: LIFE_INSURANCE_YES }, () => {
        this.getCustomerOffer(amount);
      });
    }
  };

  onChangeTenor = () => {
    const { tenors } = this.props;
    const { tenorIndex } = this.state;
    const tenor = tenors[tenorIndex].value;
    if (tenor !== this.state.tenor) {
      this.setState({ tenor });
      sendGAEvent(
        'Select_Tenor',
        'Tenor_Slider',
        'ACL_0BOD_New_Customer_Loan_Calculator',
      );
    }
  };

  getIndexTenor = tenors => Math.ceil((tenors.length - 1) / 2);

  getCustomerOffer = async amount => {
    const {
      offer: { offerId },
      onGetTenors,
    } = this.props;
    const { hasLifeInsurance } = this.state;
    const data = await onGetTenors(amount, offerId, hasLifeInsurance);

    const newState = { amount, tenor: '', errorMessage: '' };

    if (!data)
      return this.setState({
        ...newState,
        errorMessage: MESSAGE.NO_TENOR_INFO,
      });

    const tenorIndex = this.getIndexTenor(data);
    const { tenor = '' } = data[tenorIndex]?.celOffer || {};

    return this.setState({ ...newState, tenorIndex, tenor });
  };

  getTenorSelect = () => {
    const { tenors, loading } = this.props;
    const { tenor } = this.state;
    if (loading) return '';
    const defaultTenor = !isEmpty(tenors) ? last(tenors).value : '';
    return tenor || defaultTenor;
  };

  submitLoan = async () => {
    const { amount, hasLifeInsurance } = this.state;
    const tenorSelected = this.getTenorSelect();
    const { onCreateApplication, token, user, tenors } = this.props;
    const selectedTenor = tenors.find(item => item.value === tenorSelected);
    const userStatistics = await getUserStatistic();
    CredoUtils.currentUUID &&
      userStatistics.push({
        key: 'iOvation_recordNumber',
        value: CredoUtils.currentUUID,
      });
    const payload = {
      customerId: user.id,
      offerCode: selectedTenor.offerCode,
      userStatistics,
      offerDetail: {
        productCode: selectedTenor.productCode,
        expectedLoanAmount: amount,
        insurance:
          hasLifeInsurance === LIFE_INSURANCE_YES
            ? INCLUDE_LIFE_INSURANCE
            : UNINCLUDE_LIFE_INSURANCE,
        insuranceAmount: selectedTenor.celOffer.totalInsurancePremium.amount,
        tenor: tenorSelected,
      },
    };
    await onCreateApplication(payload, token);
    sendGAEvent(
      'Tap_Continue_Button',
      'Continue_Button',
      'ACL_0BOD_New_Customer_Loan_Calculator',
    );
  };

  toogleTermModal = () => {
    if (!this.state.visible) {
      sendGAEvent(
        'Tap_Insurance_Information_Button',
        'Insurance_Information_Button',
        'ACL_0BOD_New_Customer_Loan_Calculator',
      );
    }
    this.setState(prevState => ({
      visible: !prevState.visible,
    }));
  };

  updateLifeInsurance = e => {
    this.setState(
      {
        hasLifeInsurance: e.target.checked
          ? LIFE_INSURANCE_YES
          : LIFE_INSURANCE_NO,
      },
      () => {
        this.getCustomerOffer(this.state.amount);
      },
    );
    if (e.target.checked)
      return sendGAEvent(
        'Enable_Insurance_Option',
        'Insurance_Option',
        'ACL_0BOD_New_Customer_Loan_Calculator',
      );

    return sendGAEvent(
      'Disable_Insurance_Option',
      'Insurance_Option',
      'ACL_0BOD_New_Customer_Loan_Calculator',
    );
  };

  render() {
    const {
      tenors,
      loading,
      offer: {
        offerData: {
          maximalCreditAmount: { amount: maxAmount },
        },
      },
    } = this.props;

    const {
      visible,
      tenor,
      hasLifeInsurance,
      tenorIndex,
      amountIndex,
      errorMessage,
    } = this.state;
    const maxAmountNumber = maxAmount / MILLION;
    const amounts = getAmountList(maxAmountNumber + 1);
    const amountsObj = getAmountObj(amounts);
    const tenorItem = tenors.find(item => item.value === tenor) || last(tenors);
    const {
      monthlyInstallment,
      annualRate,
      dailyInstallment,
    } = getMonthlyResult(tenorItem, loading);

    const title = `Trả góp hàng tháng `;

    return (
      <div className={s.container}>
        <div className={s.content}>
          <div>
            <div className={s.selectWrapper}>
              <span>Số tiền vay</span>
              <Collapse
                visible
                className={s.collapseContainer}
                value={amountsObj[amountIndex]?.label}
              >
                <Slider
                  min={MIN_AMOUNT_NUMBER}
                  max={maxAmountNumber}
                  step={STEP}
                  value={amountIndex}
                  className={s.wrapperSlider}
                  onChange={number => {
                    amountIndex !== number &&
                      this.setState({ amountIndex: number });
                  }}
                  onChangeComplete={() => {
                    sendGAEvent(
                      'Select_Loan_Amount',
                      'Loan_Amount_Slider',
                      'ACL_0BOD_New_Customer_Loan_Calculator',
                    );
                    this.onChangeAmount(amountsObj[amountIndex].value);
                  }}
                />
                <SliderDesc
                  leftContent={`${formatCurrency(
                    MIN_AMOUNT_NUMBER * 1e6,
                    false,
                  )}₫`}
                  rightContent={`${formatCurrency(
                    maxAmountNumber * 1e6,
                    false,
                  )}₫`}
                />
              </Collapse>
            </div>

            {!errorMessage && (
              <div className={s.selectWrapper}>
                <span>Kỳ hạn</span>
                <Collapse
                  visible
                  className={s.collapseContainer}
                  value={tenors[tenorIndex]?.label}
                >
                  <Slider
                    min={0}
                    max={tenors.length - 1}
                    step={STEP}
                    value={tenorIndex}
                    className={s.wrapperSlider}
                    onChange={number =>
                      tenorIndex !== number &&
                      this.setState({ tenorIndex: number })
                    }
                    onChangeComplete={this.onChangeTenor}
                  />
                  <SliderDesc
                    leftContent={(tenors?.length && tenors[0]?.label) || ''}
                    rightContent={
                      (tenors?.length && tenors[tenors.length - 1]?.label) || ''
                    }
                  />
                </Collapse>
              </div>
            )}

            <div className={s.contentWrapper}>
              {!loading &&
                (errorMessage || (
                  <>
                    <p className={s.title}>
                      {title}
                      {hasLifeInsurance === 'YES' &&
                        '(BAO GỒM GÓI AN TÂM TÀI CHÍNH)'}
                    </p>
                    <p className={s.money}>
                      {monthlyInstallment} <span className={s.currency}>đ</span>
                    </p>
                    <div className={s.promotionWrapper}>
                      <div className={s.promotion}>
                        Tương đương với khoảng{' '}
                        <span>{dailyInstallment} đ/ ngày</span>
                      </div>
                      <div className={s.promotion}>
                        ~ LS trên dư nợ giảm dần:{' '}
                        <span>{annualRate}/ tháng</span>
                      </div>
                    </div>
                  </>
                ))}
            </div>
          </div>
          <div>
            <hr className={s.dashed} />
            <div className={s.actionWrapper}>
              <div className={s.term}>
                <SwitchButton
                  checked={hasLifeInsurance === LIFE_INSURANCE_YES}
                  onChange={this.updateLifeInsurance}
                />
                <div className={s.termContent}>
                  <div className={s.contentHeader}>
                    <span>Tôi đồng ý</span>
                    <span
                      className={s.termDetail}
                      onClick={this.toogleTermModal}
                    >
                      Xem chi tiết
                    </span>
                  </div>
                  <div className={s.termSummary}>
                    Tham gia gói An Tâm Tài Chính giúp chi trả 1 phần khoản vay
                    khi xảy ra các rủi ro không mong muốn dẫn đến mất khả năng
                    lao động/ tử vong trong suốt thời gian vay.
                  </div>
                </div>
              </div>
            </div>
            <Button className={s.getLoan} onClick={this.submitLoan}>
              TIẾP TỤC
            </Button>
          </div>
        </div>
        <Modal
          className={s.modal}
          onClose={this.toogleTermModal}
          isOpen={visible}
          footer={
            <div className={s.modalFooter}>
              <Button
                className={s.modalFooterBtn}
                onClick={this.toogleTermModal}
              >
                ĐỒNG Ý
              </Button>
            </div>
          }
        >
          <p className={s.titleModal}>Gói An Tâm Tài Chính</p>
          <div className={s.modalDes}>
            <ol>
              <li>Phí Gói An Tâm Tài Chính thấp</li>
              <li>
                Giúp hồ sơ vay dễ được phê duyệt và có thêm những lợi ích sau
                này
              </li>
              <li>
                Hỗ trợ chi trả khoản vay khi xảy ra các rủi ro không mong muốn
                như tai nạn dẫn đến mất khả năng lao động, hoặc tử vong
              </li>
              <li>Khoản bồi thường lên đến 250% giá trị khoản vay</li>
            </ol>
          </div>
        </Modal>
        {loading && <FullLoadingCycle className={s.loading} />}
      </div>
    );
  }
}

const mapStateToProps = ({ clz: { newBOD } }) => ({
  offer: newBOD.offers[0],
  tenors: newBOD.tenors,
  loading: newBOD.loading,
  user: newBOD.user,
  token: newBOD.user.token,
});

const mapDispatchToProps = dispatch => ({
  onGetTenors: (amount, offerId, hasLifeInsurance) =>
    dispatch(getCustomerOffer(amount, offerId, hasLifeInsurance)),
  onCreateApplication: (payload, token) => {
    dispatch(createApplication(payload, token));
  },
  onShowErrorNotification: message =>
    dispatch(showErrorNotification(message, true)),
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(s),
);
export default enhance(LoanCalculator);
